<template>
  <div>
    <user-detail-title
      first-bread="首页管理"
      second-bread="资质信誉"
      third-bread="案例与新闻修改"
      first-url="/user/sign"
      second-url="/user/news"
      title-name="案例与新闻修改"
    >
    </user-detail-title>
    <user-detail-base>
      <el-form label-position="left" label-width="100px" v-if="LookData">
        <el-form-item label="大类" >
          <el-select v-model="Clist.type" :placeholder="LookData.typeStr">
            <el-option
              v-for="item in Large"
              :key="item.code"
              :label="item.name"
              :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="主图">
          <el-upload action="/api/photo/uploadFile" :on-success="GetMainUrl">
            <el-button slot="trigger" size="small" type="primary">选取图片</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="标题">
          <el-input
            v-model="Clist.title" :placeholder="LookData.title"></el-input>
        </el-form-item>
        <el-form-item label="日期">
            <el-date-picker
                    v-model="Clist.eventTime"
                    type="date"
                    placeholder="日期">
            </el-date-picker>
        </el-form-item>
        <el-form-item label="摘要">
          <el-input  type="textarea"
                     :rows="3"

                     v-model="Clist.mainDescription" ></el-input>
        </el-form-item>
        <!--                     v-model="Clist.mainDescription" :placeholder="LookData.mainDescription"></el-input>-->
        <el-form-item label="描述">
          <ripeav-text-input v-model="Clist.description" :text-input="Clist.description"></ripeav-text-input>
        </el-form-item>
        <el-form-item label="预览">
          <div v-html="Clist.description" :placeholder="LookData.mainDescription"></div>
        </el-form-item>
        <el-button @click="handleChange">修改</el-button>
      </el-form>
    </user-detail-base>
  </div>
</template>

<script>
  import UserDetailTitle from "../Common/UserDetailTitle";
  import UserDetailBase from "../Common/UserDetailBase";
  import RipeavTextInput from "../../../components/tinymce/RipeavTextInput";
  export default {
    name: "NewsChange",
    components: {RipeavTextInput, UserDetailBase, UserDetailTitle},
    data(){
      return{
        Large:{},
        Small:{},
        LookData:null,
        Clist: {
          'id':this.$route.params.id,
          'type':null,
          'title':null,
          'eventTime':null,
          'mainPhotoUrl':null,
          'mainDescription':null,
          'description':null,
        },//表示Change添加的数据
      }
    },
    created() {
      this.GetLarge()

    },
    mounted() {
      this.GetLookData(this.$route.params.id)
    },
    watch:{
      'Clist.type'(code){
        if(code == 1){
          this.GetSmallFirst()
        }
        if(code == 2){
          this.GetSmallSecond()
        }
      }
    },
    methods:{
      GetMainUrl(file){
        this.Clist.mainPhotoUrl=file.data;
      },
      GetLarge(){
        this.$axios.get('/api/case/getTypeList').then(res=>{
          this.Large=res.data.data;
        })
      },
      GetSmallFirst(){
        this.$axios.get('/api/case/getCaseTypeList').then(res=>{
          this.Small=res.data.data;
        })
      },
      GetSmallSecond(){
        this.$axios.get('/api/case/getJournalismTypeList').then(res=>{
          this.Small=res.data.data;
        })
      },
      GetLookData(id){
        this.$axios.get('/api/case/getById/'+id).then(res=>{
          this.LookData=res.data.data
          console.log(res)
          // console.log(res.data.data.description)
          this.Clist.mainDescription = res.data.data.mainDescription
          this.Clist.mainPhotoUrl = res.data.data.mainPhotoUrl
          this.Clist.description = res.data.data.description
          this.Clist.eventTime = res.data.data.eventTime

          this.Clist.type = res.data.data.type
          this.Clist.title = res.data.data.title
          // this.Clist.title = res.data.data.title
          // Clist: {
          //   'id':this.$route.params.id,
          //           'type':null,
          //           'title':null,
          //           'mainPhotoUrl':null,
          //           'mainDescription':null,
          //           'description':null,
          // },//表示Change添加的数据



        })
      },
      handleChange(){
        if (this.Clist.type){

          // this.Clist.eventTime = this.Clist.eventTime.substring(0,10)

          // this.Clist.eventTime = new Date(Date.parse(this.Clist.eventTime))
          console.log(this.Clist.eventTime)
          this.$axios.post('/api/case/update',this.Clist).then(res=>{
            if(res.data.success == true){
              this.$message({
                message:'修改成功',
                type:'success'
              })
            }
          })
        } else {
          this.$message.error('类型必须选择')
        }
      }
    }
  }
</script>

<style scoped>

</style>